import React from "react";
import { Box, Skeleton } from "@mui/material";
import Grid from "@mui/material/Grid";
import { DCard } from "@ui/components/card/DCard";
import { between, colCenter } from "@ui/components/style/style";
export const APDetailsCardSkeleton = () => {
    return (React.createElement(Box, null,
        React.createElement(DCard, { sx: { mb: 1 } },
            React.createElement(Grid, { container: true, spacing: 1, alignItems: "center" },
                React.createElement(Grid, { size: { xs: 12, sm: "auto" } },
                    React.createElement(Box, { sx: Object.assign({}, between) },
                        React.createElement(Skeleton, { variant: "circular", width: 48, height: 48 }))),
                React.createElement(Grid, { size: { xs: 6, sm: 4, md: 4 } },
                    React.createElement(Skeleton, { variant: "text", width: "80%", height: 24 }),
                    React.createElement(Skeleton, { variant: "text", width: "60%", height: 20 }),
                    React.createElement(Skeleton, { variant: "rounded", width: 60, height: 20, sx: { mt: 0.5 } })),
                React.createElement(Grid, { size: { xs: 6, sm: 6, md: "grow" } },
                    React.createElement(Skeleton, { variant: "text", width: "50%", height: 20 }),
                    React.createElement(Skeleton, { variant: "text", width: "70%", height: 24 })),
                React.createElement(Grid, { size: "auto" },
                    React.createElement(Box, { sx: Object.assign(Object.assign({}, colCenter), { gap: 1 }) },
                        React.createElement(Skeleton, { variant: "rounded", width: 140, height: 36 }),
                        React.createElement(Skeleton, { variant: "rounded", width: 80, height: 36 }),
                        React.createElement(Skeleton, { variant: "rounded", width: 100, height: 36 })))))));
};
